export default {
  data: () => ({
    selectedItems:    null,
    getItems:         null,
  }),

  methods: {
    set_selectedItems() {
      this.selectedItems = { 
        ...this.selectedItems,
        [`current${this.chartIdx}`]: JSON.parse(JSON.stringify(this.current))
      }
    },
  },

  watch: {
    selectedItems() {
      this.$emit('selectedItems', this.selectedItems)
    },
  },
}